import React, { useState, useEffect, useRef } from "react";
import Navbar from "../../components/header/Header";
import { TabView, TabPanel } from "primereact/tabview";
import ProjectInfo from "./components/ProjectInfo";
import "./Device.css";
import Measurement from "./components/Measurement";
import DeviceMessaging from "./components/DeviceMessaging";
import ServerMessaging from "./components/ServerMessaging";
import Transfer from "./components/Transfer";
import DeviceService from "./DevicesService";
import AllDevices from "./components/AllDevices";
import { Toast } from "primereact/toast";
import {useNavigate, useParams} from "react-router-dom";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

const Devices = () => {
  const { t } = useTranslation();

  const toast = useRef<any>(null);
  const { id, project } = useParams<any>();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [userDetails, setUserDetails] = useState<any>([]);
  const [infoDisabled, setInfoDisabled] = useState<boolean>(true);
  const [measurementDisabled, setMeasurementDisabled] = useState<boolean>(true);
  const [deviceMessagingDisabled, setDeviceMessagingDisabled] =
    useState<boolean>(true);
  const [serverMessagingDisabled, setServerMessagingDisabled] =
    useState<boolean>(true);
  const [transferDisabled, setTransferDisabled] = useState<boolean>(true);
  const [projectName, setProjectName] = useState<string>("");
  const [did, setDid] = useState<string>("");
  const [isProject, setIsProject] = useState<boolean>(false);
  const [updateComponent, setUpdateComponent] = useState<number>(0);
  const deviceService = new DeviceService();
  const showSuccess = (message: string) => {
    toast.current.show({
      severity: "success",
      summary: "Confirmation Message",
      detail: message,
      life: 3000,
    });
  };

  const deleteDeviceInfo = () => {
    localStorage.removeItem("projectInfo");
    localStorage.removeItem("measurements");
    localStorage.removeItem("deviceMessaging");
    localStorage.removeItem("serverMessaging");
    localStorage.removeItem("transferInfo");
  };


  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);
    if (id != null && project != null) {
      setUserDetails({ id: localStorage.getItem("userId") });
      setIsProject(true);
      setActiveIndex(1);
      setProjectName(project);
      setDid(id);
    }
    else{
      setActiveIndex(0);
    }
  }, [i18n.language, updateComponent]);

  return (
    <>
      <Navbar userDetails={userDetails} />
      <Toast ref={toast} />

      <div className="grid mt-5" id="tabs">
        <div className="col-12">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            className="form_tabs"
          >
            <TabPanel header={t("devices")} leftIcon="pi pi-cog">
              <AllDevices
                onNext={(name) => {
                  setProjectName(name["projectName"]);
                  setDid(name["did"]);
                  setActiveIndex(1);
                }}
              />
            </TabPanel>

            <TabPanel
              header={t("information")}
              leftIcon="pi pi-info"
              disabled={infoDisabled}
            >
              <ProjectInfo
                did={did}
                projectName={projectName}
                userId={userDetails["id"]}
                onNext={() => {
                  setActiveIndex(2);
                  setInfoDisabled(false);
                }}
              />
            </TabPanel>
            <TabPanel
              header={t("measurements")}
              leftIcon="pi pi-database"
              disabled={measurementDisabled}
            >
              <Measurement
                did={did}
                projectName={projectName}
                userId={userDetails["id"]}
                onPrevious={() => {
                  setActiveIndex(1);
                }}
                onNext={() => {
                  setMeasurementDisabled(false);
                  setActiveIndex(3);
                }}
              />
            </TabPanel>
            <TabPanel
              header={t("device_messaging")}
              leftIcon="pi pi-comment"
              disabled={deviceMessagingDisabled}
            >
              <DeviceMessaging
                did={did}
                projectName={projectName}
                userId={userDetails["id"]}
                onPrevious={() => {
                  setActiveIndex(2);
                }}
                onNext={() => {
                  setDeviceMessagingDisabled(false);
                  setActiveIndex(4);
                }}
              />
            </TabPanel>

            <TabPanel
              header={t("transfer_other")}
              leftIcon="pi pi-check-circle"
              disabled={transferDisabled}
            >
              <Transfer
                did={did}
                projectName={projectName}
                userId={userDetails["id"]}
                onPrevious={() => {
                  setActiveIndex(3);
                }}
                onNext={() => {
                  deviceService.updateDevice(did, projectName).then(response => {
                    if(response === 200){
                      setActiveIndex(0);
                      setInfoDisabled(true);
                      setMeasurementDisabled(true);
                      setDeviceMessagingDisabled(true);
                      setTransferDisabled(true);
                      deleteDeviceInfo();
                      showSuccess(t('device_updated'));
                      setUpdateComponent(updateComponent + 1);
                      navigate(localStorage.getItem('redirect-url')!);
                      localStorage.removeItem('redirect-url');
                    }
                  })

                }}
              />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  );
};

export default Devices;
